import BaseService from "@/services/Base-service";

class CustomerService {
  get controllerName() { return '/Customer/'; }

  getCustomerList() {
    return BaseService.get(this.controllerName + 'GetCustomers');
  }

  getCustomersByParentId(parentId) {
    return BaseService.get(this.controllerName + 'GetCustomersByParentId/' + parentId);
  }

  getCustomersByCompanyId(companyId) {
    return BaseService.get(this.controllerName + 'GetCustomersByCompanyId/' + companyId);
  }

  getCustomersByCompanySectionId(sectionId) {
    return BaseService.get(this.controllerName + 'GetCustomersByCompanySectionId/' + sectionId);
  }

  getCustomer(customerId) {
    return BaseService.get(this.controllerName + 'GetCustomerById/' + customerId);
  }

  createCustomer(model) {
    return BaseService.post(this.controllerName + 'CreateCustomer', model);
  }

  updateCustomer(model) {
    return BaseService.post(this.controllerName + 'EditCustomer', model);
  }

  deleteCustomer(customerId) {
    return BaseService.post(this.controllerName + 'deleteCustomer/' + customerId);
  }

  getUserCustomersByCustomer(customerId) {
    return BaseService.get(this.controllerName + 'GetCustomersByUsersCustomerId/' + customerId);
  }

  getUserCustomersByCompany(companyIds) {
    return BaseService.post(this.controllerName + 'GetCustomersByUsersComapanyIds' , companyIds);
  }
}
export default new CustomerService();